export interface Bonus {
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    title: '🎁 BONUS 1 — Volleyball Rotation & Lineup Master System™',
    description:
      'Rotation cards, lineup worksheets, serve-receive maps, player responsibility sheets, 5-1 and 6-2 structures, rotation comparisons, and practical tools to organize your lineup and responsibilities before competition.',
  },
  {
    title: '🎁 BONUS 2 — Player Evaluation & Development Tracker™',
    description:
      'Ready-to-use assessment cards, position-specific evaluations, skill rating sheets, development plans, progress reviews, match evaluations, goal trackers, and team dashboards for monitoring player development throughout the season.',
  },
  {
    title: '🎁 BONUS 3 — Coach Communication & Feedback Playbook™',
    description:
      'Practical feedback frameworks, technical correction scripts, timeout structures, player meeting sheets, role-clarity tools, pre-match communication, and post-match debriefs designed for real coaching situations.',
  },
  {
    title: '🎁 BONUS 4 — Volleyball Match Day Command Center™',
    description:
      'Match-day checklists, opponent scouting sheets, serving targets, tactical priorities, lineup cards, timeout notes, between-set adjustments, observation tools, and post-match reviews organized into one practical competition toolkit.',
  },
  {
    title: '🎁 BONUS 5 — Volleyball Tryout & Team Selection System™',
    description:
      'Complete tryout structures, evaluation scorecards, position-specific rubrics, player comparison matrices, roster balance tools, selection sheets, and ready-to-run tryout sessions for evaluating players more efficiently.',
  },
]
